import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  selector: 'email-sign-up-verification-reminder-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './sign-up-verification-reminder.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class SignUpVerificationReminderTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<SignUpVerificationReminderTemplateData>;
}

export type SignUpVerificationReminderTemplateData = {
  title: string;
  p1: string;
  p2: string;
  button_link: string;
  button_text: string;
  footer: string;
  support_email: string;
};

export const SignUpVerificationReminderTemplateMocks: SignUpVerificationReminderTemplateData[] = [
  {
    title: 'Confirm your email',
    p1: 'Hi Julia! 👋 We see that you’ve recently signed up for Recruitee, but never confirmed your email. We get it – we’re all busy. You can do it now!',
    p2: 'Confirm your email and enjoy recruiting with Recruitee.',
    button_link: 'http://recruitee.com',
    button_text: 'Confirm email',
    footer: 'Need help?',
    support_email: 'support@recruitee.com',
  },
];
